import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { AddStudentGroupRequest } from "../edit-student-groups/add-student-group/AddStudentGroupRequest";
import { GroupActionFineInsertRequest } from "../edit-student-groups/student-group-edit/group-action-table/sgadd-fine/GroupActionFineInsertRequest";
import { GroupActionReleaseScheduleInsertRequest } from "../edit-student-groups/student-group-edit/group-action-table/sgadd-release/GroupActionReleaseScheduleInsertRequest";
import { GroupActionReleaseScheduleUpdateRequest } from "../edit-student-groups/student-group-edit/group-action-table/sgedit-release/GroupActionReleaseScheduleUpdateRequest";
import { wsGroupActionAdvancedIncidentDataParm } from "../edit-student-groups/student-group-edit/shared/GroupActionAdvanced";
import { ChangeGroupRequest } from "./ChangeGroupRequest";
import { DeleteGroupActionRequest } from "./DeleteGroupActionRequest";
import { GroupActionIncidentInsertRequest } from "./GroupActionIncidentInsertRequest";
import { GroupImportInsertStudentsRequest } from "./GroupImportInsertStudentsRequest";
import { GroupImportLoadDataRequest } from "./GroupImportLoadDataRequest";
import { UpdateStudentGroupRequest } from "./UpdateStudentGroupRequest";

@Injectable()
export class GroupsService {
	constructor(private httpclientService: HttpclientService) {}

	private subject = new Subject<any>();
	studentSelectedChanged(person) {
		this.subject.next(person);
	}

	onsStudentSelectChange(): Observable<any> {
		return this.subject.asObservable();
	}

	loadEventList(applicationItemID, schoolID, startDate, endDate, active) {
		var postResult$ = new Subject();
		if (active === "All") {
			active = 2;
		} else if (active === "Active") {
			active = 1;
		} else if (active === "Inactive") {
			active = 0;
		}

		var url =
			"EventAlert/EventsGetList?ApplicationItemID=" +
			applicationItemID +
			"&SchoolID=" +
			schoolID +
			"&StartDate=" +
			startDate +
			"&EndDate=" +
			endDate +
			"&Active=" +
			active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//For 1-time events
	insertEvent(
		applicationItemID,
		schoolID,
		eventDescShort,
		eventDescLong,
		eventLocation,
		doorsOpenTime,
		startTime,
		endTime,
		eventScanCausesAttendance,
		validateOnly,
		eventDT
	) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/EventsAddEvent?ApplicationItemID=" +
			applicationItemID +
			"&SchoolID=" +
			schoolID +
			"&EventDescShort=" +
			eventDescShort +
			"&EventDescLong=" +
			eventDescLong +
			"&EventLocation=" +
			eventLocation +
			"&DoorsOpenTime=" +
			doorsOpenTime +
			"&StartTime=" +
			startTime +
			"&EndTime=" +
			endTime +
			"&EventScanCausesAttendance=" +
			eventScanCausesAttendance +
			"&ValidateOnly=" +
			validateOnly +
			"&EventDT=" +
			eventDT;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//For recurring events
	insertRecurringEvent(
		applicationItemID,
		schoolID,
		eventDescShort,
		eventDescLong,
		eventLocation,
		doorsOpenTime,
		startTime,
		endTime,
		eventScanCausesAttendance,
		validateOnly,
		eventDT,
		scheduleTypeID,
		recurranceTypeID,
		recurrancePatternTypeID,
		recurranceRangeTypeID,
		scheduleTime,
		weekRecurCount,
		weekDaySunInd,
		weekDayMonInd,
		weekDayTueInd,
		weekDayWedInd,
		weekDayThuInd,
		weekDayFriInd,
		weekDaySatInd,
		monthEveryDOM,
		monthEveryRecurCount,
		monthOnWeekNbr,
		monthOnDOW,
		monthOnRecurCount,
		yearEveryMOY,
		yearEveryDOM,
		yearOnWeekNbr,
		yearOnDOW,
		yearOnMonth,
		rangeStartDate,
		rangeEndOccurancesTotal,
		rangeEndOccurancesCurrent,
		rangeEndDate
	) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/EventsAddRecurringEvent?ApplicationItemID=" +
			applicationItemID +
			"&SchoolID=" +
			schoolID +
			"&EventDescShort=" +
			eventDescShort +
			"&EventDescLong=" +
			eventDescLong +
			"&EventLocation=" +
			eventLocation +
			"&DoorsOpenTime=" +
			doorsOpenTime +
			"&StartTime=" +
			startTime +
			"&EndTime=" +
			endTime +
			"&EventScanCausesAttendance=" +
			eventScanCausesAttendance +
			"&ValidateOnly=" +
			validateOnly +
			"&EventDT=" +
			eventDT +
			"&ScheduleTypeID=" +
			scheduleTypeID +
			"&RecurranceTypeID=" +
			recurranceTypeID +
			"&RecurrancePatternTypeID=" +
			recurrancePatternTypeID +
			"&RecurranceRangeTypeID=" +
			recurranceRangeTypeID +
			"&ScheduleTime=" +
			scheduleTime +
			"&WeekRecurCount=" +
			weekRecurCount +
			"&WeekDaySunInd=" +
			weekDaySunInd +
			"&WeekDayMonInd=" +
			weekDayMonInd +
			"&WeekDayTueInd=" +
			weekDayTueInd +
			"&WeekDayWedInd=" +
			weekDayWedInd +
			"&WeekDayThuInd=" +
			weekDayThuInd +
			"&WeekDayFriInd=" +
			weekDayFriInd +
			"&WeekDaySatInd=" +
			weekDaySatInd +
			"&MonthEveryDOM=" +
			monthEveryDOM +
			"&MonthEveryRecurCount=" +
			monthEveryRecurCount +
			"&MonthOnWeekNbr=" +
			monthOnWeekNbr +
			"&MonthOnDOW=" +
			monthOnDOW +
			"&MonthOnRecurCount=" +
			monthOnRecurCount +
			"&YearEveryMOY=" +
			yearEveryMOY +
			"&YearEveryDOM=" +
			yearEveryDOM +
			"&YearOnWeekNbr=" +
			yearOnWeekNbr +
			"&YearOnDOW=" +
			yearOnDOW +
			"&YearOnMonth=" +
			yearOnMonth +
			"&RangeStartDate=" +
			rangeStartDate +
			"&RangeEndOccurancesTotal=" +
			rangeEndOccurancesTotal +
			"&RangeEndOccurancesCurrent=" +
			rangeEndOccurancesCurrent +
			"&RangeEndDate=" +
			rangeEndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	editEvent(
		applicationItemID,
		eventID,
		eventDescriptionID,
		schoolID,
		eventDescShort,
		eventDescLong,
		eventLocation,
		doorsOpenTime,
		startTime,
		endTime,
		eventScanCausesAttendance,
		validateOnly,
		eventDT
	) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/EventsUpdateEvent?ApplicationItemID=" +
			applicationItemID +
			"&EventID=" +
			eventID +
			"&EventDescriptionID=" +
			eventDescriptionID +
			"&SchoolID=" +
			schoolID +
			"&EventDescShort=" +
			eventDescShort +
			"&EventDescLong=" +
			eventDescLong +
			"&EventLocation=" +
			eventLocation +
			"&DoorsOpenTime=" +
			doorsOpenTime +
			"&StartTime=" +
			startTime +
			"&EndTime=" +
			endTime +
			"&EventScanCausesAttendance=" +
			eventScanCausesAttendance +
			"&ValidateOnly=" +
			validateOnly +
			"&EventDT=" +
			eventDT;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	editRecurringEvent(
		applicationItemID,
		eventID,
		eventDescriptionID,
		scheduleID,
		eventDT,
		eventDescShort,
		eventDescLong,
		eventLocation,
		doorsOpenTime,
		startTime,
		endTime,
		eventScanCausesAttendance,
		validateOnly,
		recurranceTypeID,
		recurrancePatternTypeID,
		recurranceRangeTypeID,
		weekRecurCount,
		weekDaySunInd,
		weekDayMonInd,
		weekDayTueInd,
		weekDayWedInd,
		weekDayThuInd,
		weekDayFriInd,
		weekDaySatInd,
		monthEveryDOM,
		monthEveryRecurCount,
		monthOnWeekNbr,
		monthOnDOW,
		monthOnRecurCount,
		yearEveryMOY,
		yearEveryDOM,
		yearOnWeekNbr,
		yearOnDOW,
		yearOnMonth,
		rangeStartDate,
		rangeEndOccurancesTotal,
		rangeEndDate,
		scheduleTime,
		scheduleTypeID
	) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/EventsUpdateRecurringEvent?ApplicationItemID=" +
			applicationItemID +
			"&EventID=" +
			eventID +
			"&EventDescriptionID=" +
			eventDescriptionID +
			"&ScheduleID=" +
			scheduleID +
			"&EventDT=" +
			eventDT +
			"&EventDescShort=" +
			eventDescShort +
			"&EventDescLong=" +
			eventDescLong +
			"&EventLocation=" +
			eventLocation +
			"&DoorsOpenTime=" +
			doorsOpenTime +
			"&StartTime=" +
			startTime +
			"&EndTime=" +
			endTime +
			"&EventScanCausesAttendance=" +
			eventScanCausesAttendance +
			"&ValidateOnly=" +
			validateOnly +
			"&RecurranceTypeID=" +
			recurranceTypeID +
			"&RecurrancePatternTypeID=" +
			recurrancePatternTypeID +
			"&RecurranceRangeTypeID=" +
			recurranceRangeTypeID +
			"&WeekRecurCount=" +
			weekRecurCount +
			"&WeekDaySunInd=" +
			weekDaySunInd +
			"&WeekDayMonInd=" +
			weekDayMonInd +
			"&WeekDayTueInd=" +
			weekDayTueInd +
			"&WeekDayWedInd=" +
			weekDayWedInd +
			"&WeekDayThuInd=" +
			weekDayThuInd +
			"&WeekDayFriInd=" +
			weekDayFriInd +
			"&WeekDaySatInd=" +
			weekDaySatInd +
			"&MonthEveryDOM=" +
			monthEveryDOM +
			"&MonthEveryRecurCount=" +
			monthEveryRecurCount +
			"&MonthOnWeekNbr=" +
			monthOnWeekNbr +
			"&MonthOnDOW=" +
			monthOnDOW +
			"&MonthOnRecurCount=" +
			monthOnRecurCount +
			"&YearEveryMOY=" +
			yearEveryMOY +
			"&YearEveryDOM=" +
			yearEveryDOM +
			"&YearOnWeekNbr=" +
			yearOnWeekNbr +
			"&YearOnDOW=" +
			yearOnDOW +
			"&YearOnMonth=" +
			yearOnMonth +
			"&RangeStartDate=" +
			rangeStartDate +
			"&RangeEndOccurancesTotal=" +
			rangeEndOccurancesTotal +
			"&RangeEndDate=" +
			rangeEndDate +
			"&ScheduleTime=" +
			scheduleTime +
			"&ScheduleTypeID=" +
			scheduleTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	deleteEvent(applicationItemID, eventID, eventDescriptionID) {
		var postResult$ = new Subject();
		var url = "EventAlert/EventsDeleteEvent?ApplicationItemID=" + applicationItemID + "&EventID=" + eventID + "&EventDescriptionID=" + eventDescriptionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	deleteRecurringEvent(applicationItemID, eventID, eventDescriptionID, scheduleID) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/EventsDeleteRecurringEvent?ApplicationItemID=" +
			applicationItemID +
			"&EventID=" +
			eventID +
			"&EventDescriptionID=" +
			eventDescriptionID +
			"&ScheduleID=" +
			scheduleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	toggleActiveEvent(applicationItemID, eventID, scheduleID, changeTo) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/EventsSetActive?ApplicationItemID=" + applicationItemID + "&EventID=" + eventID + "&ScheduleID=" + scheduleID + "&Active=" + changeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadScanList(applicationItemID, eventID, scanOpt, startDate, endDate) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/ScansGetList?ApplicationItemID=" +
			applicationItemID +
			"&EventID=" +
			eventID +
			"&ScanOpt=" +
			scanOpt +
			"&BeginDate=" +
			startDate +
			"&EndDate=" +
			endDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadEventDynamicGroupsList(applicationItemID, eventDescID, schoolID) {
		var postResult$ = new Subject();
		var url = "EventAlert/EventDynamicGroupsGetList?ApplicationItemID=" + applicationItemID + "&EventDescriptionID=" + eventDescID;
		"&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDynamicGroupsList(applicationItemID, audienceID) {
		var postResult$ = new Subject();
		var url = "EventAlert/DynamicGroupsGetList?ApplicationItemID=" + applicationItemID + "&AudienceID=" + audienceID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDynamicValuesList(applicationItemID, dynamicGroupSQL, schoolID) {
		var postResult$ = new Subject();
		var url = "EventAlert/DynamicValuesGetList?ApplicationItemID=" + applicationItemID + "&DynamicGroupSQL=" + dynamicGroupSQL + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadAssignStudentsAlerts(applicationItemID, schoolID, alertTypeID, active) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/AssignStudentsAlertGetList?ApplicationItemID=" +
			applicationItemID +
			"&SchoolID=" +
			schoolID +
			"&AlertTypeID=" +
			alertTypeID +
			"&Active=" +
			active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddDynamicGroup(applicationItemID, eventDescriptionID, dynamicGroupID, schoolID, dynamicGroupValue, alertID, isExclude) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/AddDynamicGroup?ApplicationItemID=" +
			applicationItemID +
			"&EventDescriptionID=" +
			eventDescriptionID +
			"&DynamicGroupID=" +
			dynamicGroupID +
			"&SchoolID=" +
			schoolID +
			"&DynamicGroupValue=" +
			dynamicGroupValue +
			"&AlertID=" +
			alertID +
			"&IsExclude=" +
			isExclude;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteEventDynamicGroup(applicationItemID, eventDynamicGroupID) {
		var postResult$ = new Subject();
		var url = "EventAlert/DeleteEventDynamicGroup?ApplicationItemID=" + applicationItemID + "&EventDynamicGroupID=" + eventDynamicGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EditDynamicGroup(applicationItemID, eventDynamicGroupID, eventDescriptionID, dynamicGroupID, schoolID, dynamicGroupValue, alertID, isExclude) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/EditEventDynamicGroup?ApplicationItemID=" +
			applicationItemID +
			"&EventDynamicGroupID=" +
			eventDynamicGroupID +
			"&EventDescriptionID=" +
			eventDescriptionID +
			"&DynamicGroupID=" +
			dynamicGroupID +
			"&SchoolID=" +
			schoolID +
			"&DynamicGroupValue=" +
			dynamicGroupValue +
			"&AlertID=" +
			alertID +
			"&IsExclude=" +
			isExclude;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadEvent(applicationItemID, eventID) {
		var postResult$ = new Subject();
		var url = "EventAlert/EventSelect?ApplicationItemID=" + applicationItemID + "&EventID=" + eventID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadScan(applicationItemID, eventScanID) {
		var postResult$ = new Subject();
		var url = "EventAlert/ScanSelect?ApplicationItemID=" + applicationItemID + "&EventScanID=" + eventScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDynamicGroupValue(applicationItemID, dgSQL, schoolID, dgValue) {
		var postResult$ = new Subject();
		var url =
			"EventAlert/LoadDynamicGroupValue?ApplicationItemID=" +
			applicationItemID +
			"&DynamicGroupSQL=" +
			dgSQL +
			"&SchoolID=" +
			schoolID +
			"&DynamicGroupValue=" +
			dgValue;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupGetList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Groups/GroupGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddStudentGroup(parms: AddStudentGroupRequest) {
		var postResult$ = new Subject();
		var url = "Groups/AddStudentGroup";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateStudentGroup(parms: UpdateStudentGroupRequest) {
		var postResult$ = new Subject();
		var url = "Groups/UpdateStudentGroup";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AssignedStudentGetList(applicationItemID, SchoolID, GroupID) {
		var postResult$ = new Subject();
		var url = "Groups/AssignedStudentGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + SchoolID + "&GroupID=" + GroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UnassignedStudentGetList(applicationItemID, SchoolID, GroupID) {
		var postResult$ = new Subject();
		var url = "Groups/UnassignedStudentGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + SchoolID + "&GroupID=" + GroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionsGetList(GroupID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionsGetList?GroupID=" + GroupID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteStudentGroup(applicationItemID, GroupID, DeletePBIS, DeleteReleases, DeleteIncidents) {
		var postResult$ = new Subject();
		var url =
			"Groups/DeleteStudentGroup?ApplicationItemID=" +
			applicationItemID +
			"&GroupID=" +
			GroupID +
			"&DeletePBIS=" +
			DeletePBIS +
			"&DeleteReleases=" +
			DeleteReleases +
			"&DeleteIncidents=" +
			DeleteIncidents;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AssignStudent(applicationItemID, GroupID, PersonID, SchoolID, AssignActions) {
		var postResult$ = new Subject();
		var url =
			"Groups/AssignStudentToGroup?ApplicationItemID=" +
			applicationItemID +
			"&GroupID=" +
			GroupID +
			"&PersonID=" +
			PersonID +
			"&SchoolID=" +
			SchoolID +
			"&AssignActions=" +
			AssignActions;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UnassignStudent(applicationItemID, GroupID, PersonID, SchoolID) {
		var postResult$ = new Subject();
		var url =
			"Groups/UnassignStudentToGroup?ApplicationItemID=" + applicationItemID + "&GroupID=" + GroupID + "&PersonID=" + PersonID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateGroup(parms: UpdateStudentGroupRequest) {
		var postResult$ = new Subject();
		var url = "Groups/UpdateGroup";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteGroupAction(parms: DeleteGroupActionRequest) {
		var postResult$ = new Subject();
		var url = "Groups/DeleteGroupAction";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineTypeGetList(applicationItemID, UserAssignable, AccountID, SchoolID) {
		var postResult$ = new Subject();
		var url =
			"Groups/FineTypeGetList?ApplicationItemID=" +
			applicationItemID +
			"&UserAssignable=" +
			UserAssignable +
			"&AccountID=" +
			AccountID +
			"&SchoolID=" +
			SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AdminGetList(applicationItemID, SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "Groups/AdminGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionFineInsert(parms: GroupActionFineInsertRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionFineInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseGetList(applicationItemID, SchoolID, IsCountAsPresent) {
		var postResult$ = new Subject();
		var url = "Groups/ExcuseGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + SchoolID + "&IsCountAsPresent=" + IsCountAsPresent;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReleaseTypeGetList(applicationItemID) {
		var postResult$ = new Subject();
		var url = "Groups/ReleaseTypeGetList?ApplicationItemID=" + applicationItemID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionReleaseScheduleInsert(parms: GroupActionReleaseScheduleInsertRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionReleaseScheduleInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionGetFullInfo(applicationItemID, GroupActionID) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionGetFullInfo?ApplicationItemID=" + applicationItemID + "&GroupActionID=" + GroupActionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionReleaseScheduleUpdate(parms: GroupActionReleaseScheduleUpdateRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionReleaseScheduleUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetPerson(applicationItemID, EntryID, IDType) {
		var postResult$ = new Subject();
		var url = "Groups/GetPerson?ApplicationItemID=" + applicationItemID + "&EntryID=" + EntryID + "&IDType=" + IDType;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionIncidentInsert(parms: GroupActionIncidentInsertRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionIncidentInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InfractionGetList(applicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Groups/InfractionGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PenaltyGetListByInfractionID(applicationItemID, InfractionID) {
		var postResult$ = new Subject();
		var url = "Groups/PenaltyGetListByInfractionID?ApplicationItemID=" + applicationItemID + "&InfractionID=" + InfractionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PenaltyGetListForGroups(applicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Groups/PenaltyGetListForGroups?ApplicationItemID=" + applicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertSelect(applicationItemID, PenaltyID) {
		var postResult$ = new Subject();
		var url = "Groups/AlertSelectFromPenalty?ApplicationItemID=" + applicationItemID + "&PenaltyID=" + PenaltyID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EditGroupActionGetList(applicationItemID, GroupActionID) {
		var postResult$ = new Subject();
		var url = "Groups/EditGroupActionGetList?ApplicationItemID=" + applicationItemID + "&GroupActionID=" + GroupActionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupAssignMultiple(parms: ChangeGroupRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupAssignMultiple";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupUnassignMultiple(parms: ChangeGroupRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupUnassignMultiple";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReleaseScheduleInsert(
		ReleaseTypeID,
		PersonID,
		Administrator_PersonID,
		GroupActionID,
		ExcuseID,
		StartDate,
		EndDate,
		AdmitTime,
		ReleaseTime,
		Comment,
		DaySun,
		DayMon,
		DayTue,
		DayWed,
		DayThu,
		DayFri,
		DaySat
	) {
		var postResult$ = new Subject();
		var url =
			"Release/ReleaseScheduleInsert?ReleaseTypeID=" +
			ReleaseTypeID +
			"&PersonID=" +
			PersonID +
			"&Administrator_PersonID=" +
			Administrator_PersonID +
			"&GroupActionID=" +
			GroupActionID +
			"&ExcuseID=" +
			ExcuseID +
			"&StartDate=" +
			StartDate +
			"&EndDate=" +
			EndDate +
			"&AdmitTime=" +
			AdmitTime +
			"&ReleaseTime=" +
			ReleaseTime +
			"&Comment=" +
			Comment +
			"&DaySun=" +
			DaySun +
			"&DayMon=" +
			DayMon +
			"&DayTue=" +
			DayTue +
			"&DayWed=" +
			DayWed +
			"&DayThu=" +
			DayThu +
			"&DayFri=" +
			DayFri +
			"&DaySat=" +
			DaySat;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Groups/ExcuseSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadReleaseSchedule(GroupActionID) {
		var postResult$ = new Subject();
		var url = "Groups/LoadReleaseSchedule?GroupActionID=" + GroupActionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionIncidentDelete(GroupActionID, RemoveDetails) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionIncidentDelete?GroupActionID=" + GroupActionID + "&RemoveDetails=" + RemoveDetails;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionReleaseScheduleDelete(GroupActionID, RemoveDetails) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionReleaseScheduleDelete?GroupActionID=" + GroupActionID + "&RemoveDetails=" + RemoveDetails;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionFineDelete(GroupActionID, RemoveDetails) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionFineDelete?GroupActionID=" + GroupActionID + "&RemoveDetails=" + RemoveDetails;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionReminderDelete(GroupActionID, RemoveFromStudents) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionReminderDelete?GroupActionID=" + GroupActionID + "&RemoveFromStudents=" + RemoveFromStudents;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionsGetListDefault(GroupID) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionsGetListDefault?GroupID=" + GroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionsGetListOptional(GroupID) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionsGetListOptional?GroupID=" + GroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionsGetListAll(GroupID) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionsGetListAll?GroupID=" + GroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	C9EventsGetList(SchoolID, BeginDate, EndDate, Active) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9EventsGetList?SchoolID=" + SchoolID + "&BeginDate=" + BeginDate + "&EndDate=" + EndDate + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	C9ScheduleGetList(SchoolID, BeginDate, EndDate, Active) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9ScheduleGetList?SchoolID=" + SchoolID + "&BeginDate=" + BeginDate + "&EndDate=" + EndDate + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupImportLoadStudentData(parms: GroupImportLoadDataRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupImportLoadStudentData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupImportInsertStudents(parms: GroupImportInsertStudentsRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupImportInsertStudents";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupPointsVoid(PointsGroupTransactionID) {
		var postResult$ = new Subject();
		var url = "PBIS/GroupPointsVoid?PointsGroupTransactionID=" + PointsGroupTransactionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
